import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { textPanelContentHeight } from '../../../store/screen/panelSelectors';
import List from './List';
import BrowseItems from './BrowseItems';
import SearchResultItems from './SearchResultItems';
import { searchResultKey, newSearchResults } from '../../../store/textPanelContent/selectors';
import { Mode, RequestStatus } from '../../../store/textPanelContent';

const Content = (): JSX.Element => {
  const {
    error,
    mode,
    searchRequestStatus,
    newRawData: newVerses,
    browseRequestStatus, // New field for browse loading state
  } = useSelector((state: RootState) => state.textPanelContent);

  const { darkMode } = useSelector((state: RootState) => state.settings);
  const { bookOrSlug, verse, chapter, textVersion } = useSelector(
    (state: RootState) => state.params
  );

  const { lineHeight } = useSelector((state: RootState) => state.textPanelSettings);

  const height = useSelector(textPanelContentHeight);
  const newResults = useSelector(newSearchResults);
  const searchKey = useSelector(searchResultKey);
  const key =
    mode === Mode.browse
      ? `${error}-${textVersion}-${bookOrSlug}-${chapter}`
      : `${error}-${searchRequestStatus}-${searchKey}`;

  const contentStyle = {
    lineHeight: (lineHeight === 'short' && 1.1) || (lineHeight === 'normal' && 1.5) || 2,
  };

  // Determine loading state for browse mode
  const isLoading = mode === Mode.browse && browseRequestStatus === RequestStatus.loading;

  // console.log({
  //   mode,
  //   isLoading,
  //   browseRequestStatus,
  //   newVersesLength: newVerses?.length,
  //   bookOrSlug,
  //   chapter,
  //   textVersion,
  // });

  return (
    <List
      darkMode={darkMode}
      selected={verse?.toString()}
      height={height}
      transitionKey={key}
      errorMessage={error}
    >
      <div style={contentStyle}>
        {mode === Mode.browse ? (
          <BrowseItems newVerses={newVerses ?? []} isLoading={isLoading} />
        ) : (
          <SearchResultItems requestStatus={searchRequestStatus} items={newResults} />
        )}
      </div>
    </List>
  );
};

export default Content;
